
/**
 * Formats a number as currency in US format
 * @param value - The numeric value to format
 * @param showCents - Whether to show cents (default: true)
 * @returns Formatted currency string (e.g., "$20,650.00")
 */
export function formatCurrency(value: number | null | undefined, showCents: boolean = true): string {
  if (value === null || value === undefined || isNaN(value)) {
    return showCents ? '$0.00' : '$0';
  }
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: showCents ? 2 : 0,
    maximumFractionDigits: showCents ? 2 : 0,
  }).format(value);
}

export function createPageUrl(pageName: string, params?: Record<string, any>) {
  const base = '/' + pageName.toLowerCase().replace(/ /g, '-');
  if (!params || Object.keys(params).length === 0) return base;
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      search.append(key, String(value));
    }
  });
  const qs = search.toString();
  return qs ? `${base}?${qs}` : base;
}